document.addEventListener("DOMContentLoaded", () => {

    const tabLinks = document.querySelectorAll('[js-tabs-link]');
    tabLinks.forEach(tabLink => {
        tabLink.addEventListener('click', event => {
            event.preventDefault();
            setActiveLinks(tabLinks, tabLink);
            setActiveContent(tabLink);
        });
    })

});

const setActiveLinks = (allLinks, selectedLink) => {
    allLinks.forEach(link => link.classList.remove('selected'));
    selectedLink.classList.add('selected');
};

const setActiveContent = (selectedLink) => {
    const contentId = selectedLink.getAttribute('href');
    document.querySelector('[js-tabs-displayed="true"]').setAttribute('js-tabs-displayed', false);
    document.getElementById(contentId).setAttribute('js-tabs-displayed', true);
};
